// extracted by mini-css-extract-plugin
module.exports = {"comp":"NavPage_comp__Y4fAD"};